import { api, authenticated } from '.';

// eslint-disable-next-line import/prefer-default-export
export const contextualIndicatorByFederal = (params: Record<string, any>) =>
  authenticated(api).get(`contextual-indicator-by-federal/`, { params });

export const contextualIndicatorByFederalMap = (params: Record<string, any>) =>
  authenticated(api).get(`contextual-indicator-map/`, { params });

export const getOverlayPopupData = (featureId: number) =>
  authenticated(api).get(`overlay-data/?feature=${featureId}`);
